import customer1 from "./images/customers/6557b826-be03-4be4-b71e-6a446c0a1ef8.jpeg";
import customer3 from "./images/customers/90a14b24-d405-40d2-9de6-b93cf98de371.jpeg";
import customer2 from "./images/customers/975ccca4-76d8-40fc-a2a8-58e89d4554dc.jpeg";

import logo from "./images/logo.svg";

import startSectionIcon from "./images/section-icons/power.svg"
import howWeHelpIcon from "./images/section-icons/money-back.svg"
import consultIcon from "./images/section-icons/consulting.svg"
import qualityIcon from "./images/section-icons/quality.svg"
import reliabilityIcon from "./images/section-icons/reliability.svg"
import organizationIcon from "./images/section-icons/organization.svg"
import budgetIcon from "./images/section-icons/budget.svg"
import uaeIcon from "./images/flags/united-arab-emirates.svg"
import ukIcon from "./images/flags/united-kingdom.svg"
import russiaIcon from "./images/flags/russia.svg"

import fevnusTeam from "./images/fevnus-team.png";

import { BsShieldCheck, BsClipboardCheck, BsFileEarmarkText, BsBank, BsTelephone, BsArrowRightCircle, BsCheckCircle } from 'react-icons/bs';

const lawPageData = {
  banner: {
    title: "Fevnus: юридическая опора, когда нужно действовать точно",
    subtitle:
      "В правовых вопросах важны не обещания, а ясность и грамотные шаги. Мы помогаем быстро разобраться в ситуации, оценить риски и выстроить рабочую линию защиты — от консультации до результата.",
    btn: "Получить бесплатную консультацию",
  },

  services: {
    title: "Чем мы можем помочь",
    subtitle:
      "Берём на себя ключевые юридические задачи: анализ, документы, переговоры и представительство — по делу и без лишней бюрократии.",
    items: [
      {
        icon: BsShieldCheck,
        title: "Первичная консультация",
        text:
          "Бесплатно уточняем детали, задаём правильные вопросы и объясняем, какие варианты действий действительно подходят вашей ситуации.",
      },
      {
        icon: BsClipboardCheck,
        title: "Правовой разбор материалов",
        text:
          "Проверяем договоры, переписку, платежные документы и факты. Находим слабые места, формируем позицию и оцениваем перспективы без «розовых очков».",
      },
      {
        icon: BsFileEarmarkText,
        title: "Документы, которые работают",
        text:
          "Готовим претензии, заявления, обращения и жалобы с учётом законодательства и практики — так, чтобы они давали результат, а не «для галочки».",
      },
      {
        icon: BsBank,
        title: "Представительство и сопровождение",
        text:
          "Защищаем ваши интересы в судах, госорганах и на переговорах. Доводим процесс до решения, фиксируем ход и контролируем выполнение.",
      },
    ],
  },

  howGetHelp: {
    title: "Как строится работа",
    subtitle:
      "Понятный процесс: вы видите логику шагов и понимаете, что происходит на каждом этапе.",
    items: [
      {
        step: "1",
        text:
          "Оставляете заявку на сайте или связываетесь с нами удобным способом.",
      },
      {
        step: "2",
        text:
          "Коротко описываете ситуацию и, при наличии, передаёте документы/материалы.",
      },
      {
        step: "3",
        text:
          "Получаете бесплатный первичный разбор и рекомендации по дальнейшим действиям.",
      },
      {
        step: "4",
        text:
          "Согласовываем план, формат сопровождения и запускаем работу по вашей задаче.",
      },
    ],
  },

  whyWe: {
    title: "Почему выбирают Fevnus",
    descr:
      "Мы не ограничиваемся советами — мы выстраиваем решение и сопровождаем до результата.",
    list: [
      "Команда практикующих юристов и адвокатов с опытом в сложных кейсах.",
      "Бесплатная первичная консультация — без давления и навязанных услуг.",
      "Акцент на понятной стратегии: объясняем шаги и риски человеческим языком.",
      "Прозрачные условия: заранее согласуем объём работ и стоимость.",
    ],
  },

  contact: {
    title: "Бесплатная консультация юриста",
    subtitle:
      "Оставьте заявку — мы свяжемся с вами, уточним детали и дадим первичные рекомендации. Это бесплатно и помогает быстро понять, как действовать дальше.",
  },

  whatYouGet: {
    title: "Что вы получите",
    afterListText:
      "Отправляя форму, вы подтверждаете согласие с нашей Политикой конфиденциальности и Пользовательским соглашением. Открыть документы можно прямо из формы.",
    items: [
      "Быстрый разбор ситуации и уточняющие вопросы по сути дела",
      "Понимание рисков, сроков и возможных сценариев",
      "Пошаговый план действий под вашу задачу",
      "Рекомендации по документам и формулировкам, которые усилят позицию",
    ],
  },
};

const bannerData = function slidesData() {
  return {
    icon: startSectionIcon,
    title: "Помогаем восстановить контроль над вашими средствами",
    firstBlock: "Взвешенно. Законно. С ориентацией на реальный итог",
    secondBlock:
      "Проблемы с брокером или финансовой платформой часто развиваются стремительно — блокировки, отказы в выводе, игнорирование обращений. Fevnus подключается на этапе, когда важно действовать точно и последовательно. Мы анализируем ситуацию, фиксируем ключевые факты и помогаем выстроить практический сценарий возврата средств.",
    btn: "Запустить процесс возврата",
    logo: logo,
    cFtitle: "Бесплатный разбор ситуации",
    cFtext:
      "Оставьте контакты — мы свяжемся с вами, изучим детали и подскажем, какие шаги имеют смысл именно в вашем случае"
  };
};

const howTo = function howToStartData() {
  const colors = ["#731425", "#0d0d0d"];

  return {
    icon: howWeHelpIcon,
    title: "Как Fevnus работает с возвратом средств",
    descr:
      "Fevnus сопровождает клиентов в спорах с брокерами и финансовыми сервисами, где стандартные обращения перестают работать. Мы не ограничиваемся консультациями — наша задача разобрать ситуацию по фактам, определить рабочие инструменты и довести процесс до логического результата.",
    list_title: "Формат работы с Fevnus — это:",
    list: [
      {
        title: "Старт без обязательств",
        text: "Вы получаете первичную оценку ситуации и понимание перспектив без каких-либо затрат.",
        color: colors[0],
      },
      {
        title: "Работа с банковскими механизмами",
        text: "Подключаем процедуры возврата через финансовые учреждения, если они применимы к вашему кейсу.",
        color: colors[0],
      },
      {
        title: "Фокус на досудебные решения",
        text: "В приоритет ставим способы урегулирования, позволяющие сократить сроки и избежать лишней бюрократии.",
        color: colors[0],
      },
      {
        title: "Индивидуальная стратегия",
        text: "Каждое дело разбирается отдельно — без шаблонов и универсальных обещаний.",
        color: colors[1],
      },
      {
        title: "Подготовка доказательной базы",
        text: "Помогаем структурировать документы, переписки и платежи так, чтобы они работали на результат.",
        color: colors[0],
      },
      {
        title: "Корректные юридические формулировки",
        text: "Готовим обращения и претензии с учётом реальной практики, а не формальных требований.",
        color: colors[1],
      },
      {
        title: "Анализ цепочек переводов",
        text: "Разбираем движение средств и возможные точки воздействия в сложных схемах.",
        color: colors[1],
      },
      {
        title: "Сопровождение до завершения",
        text: "Мы ведём процесс последовательно и держим вас в курсе каждого этапа.",
        color: colors[1],
      },
      {
        title: "Понятная коммуникация",
        text: "Без перегруженной терминологии и размытых формулировок — только по существу.",
        color: colors[0],
      },
    ],
    afterText:
      "Оставьте заявку — мы зададим уточняющие вопросы и предложим наиболее рациональный сценарий действий.",
  };
};

const pricingData = function pricingData() {
  return {
    title: "Как формируется стоимость работы",
    descr:
      "В Fevnus мы не продаём «попытки» и не работаем по фиксированным прайсам. Условия сотрудничества выстроены так, чтобы финансовый риск для клиента был минимальным.",
    icon: budgetIcon,
    list: [
      {
        title: "Первичный этап — бесплатно",
        text: "Анализ ситуации, обсуждение возможных путей и оценка шансов проводятся без оплаты.",
      },
      {
        title: "Отсутствие аванса",
        text: "Мы не берём предоплату и не требуем финансовых обязательств до начала результата.",
      },
      {
        title: "Вознаграждение по факту",
        text: "Оплата рассчитывается как заранее согласованный процент от реально возвращённой суммы.",
      },
      {
        title: "Отказ от формального подхода",
        text: "Если дело не имеет практических перспектив, мы честно сообщаем об этом на старте.",
      },
      {
        title: "Совпадение интересов",
        text: "Чем выше результат для клиента — тем выше мотивация команды Fevnus.",
      },
    ],
    afterText:
      "Такой подход исключает навязывание услуг и позволяет сосредоточиться исключительно на достижении результата.",
    ctaTitle:
      "Хотите понять, насколько реален возврат именно в вашей ситуации? Оставьте заявку — первичный разбор бесплатный.",
    ctaDesc:
      "Мы работаем с клиентами из разных стран и взаимодействуем с финансовыми и юридическими структурами в нескольких юрисдикциях.\nНаличие офисов и партнёрских команд в разных регионах ускоряет процесс и расширяет инструменты воздействия.",
    ctaIcon: consultIcon,
    ctaAdresses: [
      {
        country: "Россия",
        city: "Москва",
        address: "Бизнес-центр «Белые Сады», ул. Летниковская, д. 10, стр. 2, офис 503",
        icon: russiaIcon,
      },
      {
        country: "Великобритания",
        city: "Лондон",
        address: "25 Canada Square, Canary Wharf, London E14 5LQ, United Kingdom",
        icon: ukIcon,
      },
      {
        country: "ОАЭ",
        city: "Дубай",
        address: "Dubai International Financial Centre, Gate Avenue, Dubai",
        icon: uaeIcon,
      }
    ],
  };
};

const returnFundsData = function returnFundsData() {
  return {
    title: "Почему выбирают Fevnus",
    descr:
      "Мы не обещаем невозможного и не усложняем процесс без необходимости. В работе с клиентами для нас важны прогнозируемость, честность и практический результат.",
    list_title: "Что отличает нас:",
    icon: qualityIcon,
    list: [
      {
        title: "Оценка без иллюзий",
        text: "Мы беремся только за те кейсы, где видим обоснованные шансы на возврат.",
      },
      {
        title: "Отсутствие финансового давления",
        text: "Вы не несёте затрат до момента фактического результата.",
      },
      {
        title: "Комбинированные инструменты",
        text: "Используем юридические, финансовые и аналитические методы в комплексе.",
      },
      {
        title: "Прозрачный процесс",
        text: "Вы понимаете, что происходит и какие шаги предпринимаются на каждом этапе.",
      },
      {
        title: "Минимальная вовлечённость",
        text: "Мы берём на себя основную нагрузку и коммуникацию со всеми сторонами.",
      },
    ],
    afterText:
      "Fevnus — это сопровождение, ориентированное на итог, а не на количество консультаций."
  };
};

const whyWe = function whyWe() {
  const colors = ["#25c560", "#eac433"];

  return {
    title: "Как выстроен процесс возврата",
    descr:
      "Мы придерживаемся понятного алгоритма работы, чтобы клиент с самого начала понимал логику действий и ожидаемые этапы.",
    icon: consultIcon,
    list: [
      {
        text: "Вы оставляете заявку и описываете ситуацию",
        color: colors[0],
      },
      {
        text: "Мы изучаем кейс и проводим бесплатный разбор",
        color: colors[1],
      },
      {
        text: "Определяем стратегию и фиксируем условия сотрудничества",
        color: colors[0],
      },
      {
        text: "Запускаем процесс и сопровождаем его до завершения",
        color: colors[1],
      },
    ],
    subtitle: "Без сложных схем и скрытых условий",
    subdescr:
      "Вы всегда понимаете текущий статус и следующие шаги. Мы работаем последовательно и держим связь на каждом этапе.",
    cFtitle: "Получить бесплатную консультацию",
  };
};

const aboutUs = {
  title: "О компании Fevnus",
  icon: organizationIcon,
  image: fevnusTeam,
  descr:
    "Fevnus — команда специалистов, работающих с возвратом средств в сложных финансовых спорах. За годы практики мы разобрали сотни ситуаций, связанных с брокерскими конфликтами, и сформировали подход, основанный на реальных механизмах, а не теоретических советах.",
  subtitle: "",
  subdescr:
    "Мы постоянно адаптируем инструменты и подходы под изменения финансовой среды. В работе используем сочетание правовой экспертизы и аналитических решений, позволяющих разбираться даже в нестандартных случаях.",
  subdescr2:
    "Наша позиция проста: честно оценивать перспективы, не создавать ложных ожиданий и сопровождать клиента только там, где возможен результат.",
};


const secondData = function secondData() {
  return {
    titleLeft: "Don't waste your time. It's time to get your money back!",
    titleRight: "Оставить заявку на бесплатную консультацию",
    textLeft: "Regardless of who stole your money, a fraudulent broker, bookmaker or casino, the time factor is very important. Experienced professionals of our company will take all the necessary measures and get your money back.",
    textRight:
      "",
    btn: "Отправить заявку",
  };
};

const customersData = {
  title: "Отзывы клиентов Fevnus",
  icon: reliabilityIcon,
  desc:
    "Лучшее подтверждение нашей работы — опыт клиентов, которые прошли процесс возврата вместе с Fevnus.",
  list: [
    {
      img: customer1,
      author: "Алексей Морозов",
      text: "В моём случае речь шла о споре с брокером и замороженных средствах. В Fevnus сразу обозначили реальные перспективы и не пытались «продать надежду». Процесс был чётко структурирован, коммуникация — понятная. Итогом стал полный возврат средств.",
    },
    {
      img: customer3,
      author: "Алевтина Козлова",
      text: "После потери денег было сложно трезво оценить ситуацию. Специалисты Fevnus подробно разобрали мой кейс, объяснили риски и возможные варианты. Всё происходило спокойно и без давления. Через несколько недель деньги удалось вернуть.",
    },
    {
      img: customer2,
      author: "Рустам Гайсин",
      text: "Когда брокер отказал в выводе средств, я понял, что самостоятельно не справлюсь. В Fevnus взяли на себя весь процесс — от подготовки обращений до финального результата. Мне не приходилось постоянно участвовать, и это было большим плюсом.",
    },
  ],
};

const PrivacyPolicyData = (
    <>
      <h5>1. Общие положения</h5>
      <p>
        Настоящая Политика описывает, как сайт <strong>Fevnus.com</strong> обрабатывает персональные данные
        пользователей формы обратной связи и иных веб-форм. Мы руководствуемся принципами необходимости,
        законности, прозрачности и минимизации данных.
      </p>

      <h5>2. Состав обрабатываемых данных</h5>
      <p>
        При отправке формы мы можем обрабатывать: имя, адрес электронной почты, номер телефона, содержимое
        сообщения, а также технические данные (IP-адрес, user-agent, реферер, параметры устройства, cookies).
        Данные указываются пользователем добровольно, за исключением технических данных, собираемых автоматически
        для функционирования сервиса, обеспечения безопасности и аналитики.
      </p>

      <h5>3. Цели обработки</h5>
      <ul>
        <li>Идентификация обращений и коммуникация с пользователем;</li>
        <li>Подготовка консультаций и ответов на запросы;</li>
        <li>Исполнение пользовательских запросов и улучшение качества сервиса;</li>
        <li>Аналитика использования сайта и предотвращение злоупотреблений;</li>
        <li>Соблюдение требований применимого права (включая хранение логов обращений).</li>
      </ul>

      <h5>4. Правовые основания</h5>
      <p>
        Обработка осуществляется на основании добровольного волеизъявления пользователя (отправка формы),
        а также на основании законного интереса владельца сайта — предоставлять и улучшать сервис,
        обеспечивать его безопасность и надёжность.
      </p>

      <h5>5. Передача и хранение данных</h5>
      <p>
        Данные могут храниться во внутренней инфраструктуре и/или у квалифицированных поставщиков
        облачных и почтовых сервисов. Мы применяем организационные и технические меры защиты, включая
        разграничение доступа, шифрование каналов связи и аудит событий безопасности.
      </p>

      <h5>6. Сроки обработки</h5>
      <p>
        Данные хранятся не дольше, чем это необходимо для целей, указанных в настоящей Политике, после чего
        удаляются или анонимизируются. Отдельные сведения могут храниться дольше, если это требуется законом
        или необходимо для защиты прав и законных интересов.
      </p>

      <h5>7. Права пользователя</h5>
      <ul>
        <li>Получать информацию об обработке своих данных;</li>
        <li>Запрашивать уточнение, обновление или удаление предоставленных данных в пределах закона;</li>
        <li>Ограничивать обработку и возражать против отдельной обработки, если такое право предоставлено законом;</li>
        <li>Отзывать согласие на обработку данных, если обработка основана на согласии.</li>
      </ul>

      <h5>8. Cookies и аналитика</h5>
      <p>
        Мы можем использовать cookies и схожие технологии для персонализации интерфейса, аналитики трафика и
        улучшения производительности. Пользователь может управлять cookies в настройках браузера; ограничение
        cookies может повлиять на корректность работы отдельных функций сайта.
      </p>

      <h5>9. Обновления Политики</h5>
      <p>
        Политика может периодически обновляться для отражения изменений сервиса и требований законодательства.
        Актуальная версия всегда доступна на сайте <strong>Fevnus.com</strong>.
      </p>
    </> );

const TermsOfUseData = (
        <>  
      <h5>1. Предмет соглашения</h5>
      <p>
        Настоящее Соглашение регулирует использование пользователем веб-сайта <strong>Fevnus.com</strong> и его
        функциональности (включая формы обратной связи). Используя сайт, пользователь подтверждает, что
        ознакомился с Соглашением и обязуется его соблюдать.
      </p>

      <h5>2. Использование сайта</h5>
      <ul>
        <li>Пользователь обязуется предоставлять достоверные сведения при заполнении форм;</li>
        <li>Запрещено нарушать безопасность, пытаться получить несанкционированный доступ, размещать вредоносные данные;</li>
        <li>Запрещено использовать сайт для рассылки спама, мошенничества и иных противоправных действий;</li>
        <li>Владелец сайта вправе ограничить доступ при нарушении Соглашения или угрозе безопасности сервиса.</li>
      </ul>

      <h5>3. Консультации и информация</h5>
      <p>
        Материалы на сайте носят информационный характер и не являются индивидуальной юридической рекомендацией.
        Окончательные выводы и действия формируются с учётом предоставленных пользователем данных и могут требовать
        дополнительной проверки документов и обстоятельств.
      </p>

      <h5>4. Интеллектуальная собственность</h5>
      <p>
        Контент сайта (тексты, графика, логотипы, интерфейс) охраняется правом. Пользователь получает ограниченную
        неисключительную лицензию на личное использование сайта и не вправе копировать или распространять контент
        без разрешения правообладателя.
      </p>

      <h5>5. Ограничение ответственности</h5>
      <p>
        Сайт предоставляется «как есть». Владелец сайта стремится к бесперебойной работе сервиса, однако не
        гарантирует его абсолютную доступность или безошибочность. Ответственность за корректность введённых
        пользователем данных несёт пользователь.
      </p>

      <h5>6. Взаимодействие с третьими лицами</h5>
      <p>
        Сайт может содержать ссылки на сторонние ресурсы. Мы не контролируем их содержание и политику обработки
        данных и не несём ответственность за действия третьих лиц.
      </p>

      <h5>7. Изменения условий</h5>
      <p>
        Владелец сайта может обновлять Соглашение в любой момент для отражения изменений сервиса. Продолжение
        использования сайта означает согласие с обновлёнными условиями.
      </p>
    </> );

const footerData = function footerData() {
  return {
    brand: {
      logo,
      alt: "Fevnus",
      tagline:
        "Юридическая и организационная поддержка для возврата средств от брокера. Работаем системно: от первичного анализа до сопровождения действий по вашему делу.",
      trust: [
        "Первичный разбор — бесплатно",
        "Оплата — после выполненной работы / результата*",
        "Понятный план действий и отчётность по этапам",
      ],
    },

    columns: [
      {
        title: "Навигация",
        type: "links",
        items: [
          { label: "О компании", href: "#about" },
          { label: "О процедуре возврата", href: "#howToStart" },
          { label: "Почему выбирают нас", href: "#benefits" },
          { label: "Стоимость", href: "#pricing" },
          { label: "Оставить заявку", href: "#contact-cta" },
        ],
      },
      {
        title: "Что вы получите",
        type: "list",
        items: [
          { label: "Оценку перспектив именно вашего случая" },
          { label: "Чек-лист доказательств и необходимых документов" },
          { label: "Пошаговую стратегию с приоритетами и сроками" },
          { label: "Сопровождение обращений и коммуникаций по делу" },
        ],
      }
    ],

    bottom: {
      mini: [
        {
          label: "Подход:",
          text: "анализ → стратегия → действия → сопровождение → контроль результата",
        },
        {
          label: "Примечание:",
          text: "* Условия оплаты зависят от кейса и фиксируются в договоре после первичного анализа.",
        },
      ],
      badges: ["Case-first", "Transparent process", "No upfront fees"],
      copyright:
        "© {year} Fevnus. Все права защищены.",
    },
  };
};

const reliableData = function reliableData() {
  return {
    title: "Fevnus - a reliable partner, assistant and source of information about finance and investment",
    descr: "Get all the information you need to be successful and safe in the finance industry. If you already have a bad experience of interacting with scammers, we will help you get your money back.",
  };
};

export {
  pricingData,
  returnFundsData,
  bannerData,
  howTo,
  whyWe,
  aboutUs,
  secondData,
  customersData,
  PrivacyPolicyData,
  TermsOfUseData,
  reliableData,
  footerData,
  lawPageData
};